import { Suspense, useState } from "react";

import { KeyboardControls, Loader, OrbitControls, PerformanceMonitor, Stars } from "@react-three/drei";
import { Bloom, EffectComposer } from "@react-three/postprocessing";
import { Physics } from "@react-three/rapier";
import { Canvas } from "@react-three/fiber";
import { Perf } from "r3f-perf";

import { Interface } from "@experience/Interface";
import { Lights } from "@fiber/Lights";
import { Player } from "@game/Player";
import { Level } from "@game/Level";
import { Debug } from "@debug";

import useGame from "@stores/useGame";

export function Experience() {
    const [bad, setBad] = useState(false);

    const blocksCount = useGame((state) => state.blocksCount);
    const blockSeed = useGame((state) => state.blockSeed);
    const blockSize = useGame((state) => state.blockSize);
    const enableOrbitControls = useGame((state) => state.enableOrbitControls);

    return (
        /**
         * To refer to the key in all type of keyboard, needs use "Key" in front the letter
         * To refer to the exacly letter, use just de letter
        */
        <KeyboardControls
            map={
                [
                    { name: "forward", keys: ["ArrowUp", "KeyW"] },
                    { name: "backward", keys: ["ArrowDown", "KeyS"] },
                    { name: "leftward", keys: ["ArrowLeft", "KeyA"] },
                    { name: "rightward", keys: ["ArrowRight", "KeyD"] },
                    { name: "jump", keys: ["Space"] },
                    { name: "reset", keys: ["r", "R"] },
                    { name: "audio", keys: ["m", "M"] }
                ]}
        >
            <Suspense fallback={<Loader />}>
                <Canvas
                    shadows
                    camera={{
                        fov: 45,
                        near: 0.1,
                        far: 200,
                        position: [2.5, 4, 6]
                    }}
                    dpr={1}
                    gl={{
                        antialias: window.devicePixelRatio <= 1,
                    }}
                >
                    <color attach="background" args={['#151520']} />

                    <PerformanceMonitor onDecline={() => setBad(true)} />
                    {/* <Perf position="top-left" /> */}

                    <Stars radius={90} depth={1} count={3000} factor={4} saturation={0} fade speed={2} />

                    <OrbitControls enabled={enableOrbitControls} makeDefault />

                    {
                        !bad &&
                        <EffectComposer disableNormalPass>
                            <Bloom mipmapBlur luminanceThreshold={1} intensity={2} />
                        </EffectComposer>
                    }

                    {/**
                     * Need to be around all elements that will be use Physics
                     */}
                    <Physics debug={false}>
                        <Lights />
                        <Level bad={bad} count={blocksCount} seed={blockSeed} size={blockSize} />
                        <Player />
                    </Physics>
                </Canvas>
            </Suspense>

            <Interface />

            <Debug />
        </KeyboardControls>
    );
}